import React, { FC, ReactNode, useState } from 'react';
import Button from '../Button/Button';
import classes from './Alert.module.scss';
import Axl from '../../../containers/Axl';
import Modal from '../../../containers/Modal/Modal';
import Input from '../Input/Input';

interface AlertProps {
  isOpen: boolean;
  message: string | ReactNode;
  isConfirm?: boolean;
  confirm?: (confirmValue: boolean, optionIndex?: number) => void;
  ok?: () => void;
  options?: string[];
  isDeleteConfirm?: boolean;
}

const Alert: FC<AlertProps> = (props) => {
  const [deleteName, setDeleteName] = useState('');

  if (!props.isOpen) return null;

  return (
    <Modal className={classes.modal} zIndex={9999}>
      <div>
        <span>{props.message}</span>
      </div>

      <div className={classes.footer}>
        {(props.options?.length ?? 0) > 0 ? (
          <Axl>
            <div className='mt-3'>
              <Button
                type='button'
                buttonStyle='main'
                text='Cancel'
                click={() => props.confirm && props.confirm(false)}
              />
            </div>

            {props.options?.map((option, index) => (
              <div className='mt-3'>
                <Button
                  key={index}
                  type='button'
                  buttonStyle='main'
                  text={option}
                  click={() => props.confirm && props.confirm(true, index)}
                />
              </div>
            ))}
          </Axl>
        ) : null}

        {props.isConfirm && (props.options?.length ?? 0) === 0 ? (
          <Axl>
            <Button
              type='button'
              buttonStyle='main'
              text='Cancel'
              click={() => props.confirm && props.confirm(false)}
            />
            <Button
              type='button'
              buttonStyle='main'
              text='Yes'
              click={() => props.confirm && props.confirm(true)}
            />
          </Axl>
        ) : null}

        {!props.isConfirm && !props.isDeleteConfirm ? (
          <Axl>
            <Button
              type='button'
              buttonStyle='main'
              text='Ok'
              click={props.ok}
            />
          </Axl>
        ) : null}

        {props.isDeleteConfirm ? (
          <>
            <div className={classes.deleteConfirm}>
              <Input
                elementType='input'
                elementConfig={{
                  type: 'text',
                  placeholder: '1010'
                }}
                inputStyle='inline'
                value={deleteName}
                change={(e: any) => setDeleteName(e.target.value)}
                id='delete-name'
              />

              <Button
                type='button'
                buttonStyle='main'
                text='Delete'
                disabled={deleteName !== '1010'}
                click={() => {
                  if (deleteName === '1010') {
                    props.confirm && props.confirm(true);
                  }
                }}
              />
            </div>

            <div className={classes.cancelButton}>
              <Button
                type='button'
                buttonStyle='main'
                text='Cancel'
                click={() => props.ok && props.ok()}
              />
            </div>
          </>

        ) : null}
      </div>
    </Modal>
  );
};

export default Alert;
